module.exports = __webpack_public_path__ + "static/media/quieromibarrio3.a58710c7.webp";